<template>
  
  <div class="quarter-range">
    <!-- 透明遮罩 -->
    <div class="mark"
         v-if="show_quarter_range_picker"
         @click.stop="handleClosePicker"></div>

    <!-- 结果显示框 -->
    <el-date-picker v-if="!isNoStartOne" :value="showValue"
                    popper-class="quarter-range-date-popper"
                    type="monthrange"
                    format="yyyy-MM"
                    class="mo-date-picker"
                    range-separator="~"
                    @focus="handleOpenPicker"
                    style="cursor: pointer;"
                    size="mini"
                    @change="handleChange"
                    :clearable="false"
                    :editable="false"
                    start-placeholder="开始季度"
                    end-placeholder="结束季度">
    </el-date-picker>
    <el-input v-if="isNoStartOne" :value="getValue" readonly @focus="handleOpenPicker"></el-input>

    <el-collapse-transition>
      <el-card class="quarter-range__box-card"
               v-show="show_quarter_range_picker">
        
        <div class="quarter__header">
          <i :class="['el-icon-d-arrow-left',  leftDisabled ? 'right-disabled' : '']" @click="handlePrevYear"></i>
          <div class="quarter-picker__title">{{ year }}</div>
          <i :class="['el-icon-d-arrow-right', rightDisabled ? 'right-disabled' : '']" @click="handleNextYear"></i>
        </div>
        <div class="quarter-range__box-card_box">
          <div @click="selectQuarter(index)" :class="['quarter-range__box-card-item', (index === selectIndex && year == selectYear) ? 'item_selected' : '', itemDisabled(index) ? 'item_disabled' : '']" v-for="(item, index) in ['一', '二', '三', '四']" :key="item">
            {{ `第${item}季度` }}
          </div>
        </div>
      </el-card>
    </el-collapse-transition>
  </div>
</template>
<script>
import moment from 'moment'
export default {
  components: {},
  props: {
    // [起始日期，结束日期]
    value: {
      type: Array,
      default: null,
    },
    isNoStartOne: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      show_quarter_range_picker: false,
      year: '2024',
      selectIndex: -1,
      selectYear: '2024'
    }
  },
  watch: {
  },
  computed: {
    getValue(){
      let obj = {
        1: '一',
        2: '二',
        3: '三',
        4: '四'
      }
      if (this.value) {
        let end_date = moment(this.value[1]).format('YYYY-MM');
        this.selectIndex = moment(end_date).quarter() - 1
        this.selectYear = moment(end_date).format('YYYY')
        this.year = moment(end_date).format('YYYY')
        return `${this.selectYear}年第${obj[moment(end_date).quarter()]}季度`
      } else {
        this.selectIndex = -1
        this.selectYear = null
        return ''
      }
    },
    leftDisabled(){
      return parseInt(this.year) <= parseInt(moment().add(-1,'Y').format('YYYY'))
    },
    rightDisabled(){
      return parseInt(this.year) >= parseInt(moment().format('YYYY'))
    },
    itemDisabled(){
      return function(index){
        if(this.year == moment().format('YYYY') && moment().quarter() <= index ){
          return true
        }
        return false
      }
    },
    showValue() {
      if (this.value) {
        let start_date = moment(this.value[0]).format('YYYY-MM');
        let end_date = moment(this.value[1]).format('YYYY-MM');
        this.selectIndex = moment(end_date).quarter() - 1
        this.selectYear = moment(end_date).format('YYYY')
        this.year = moment(end_date).format('YYYY')
        return [`${start_date}`, `${end_date}`]
      } else {
        this.selectIndex = -1
        this.selectYear = null
        return null
      }
    },
  },
  created() {

  },
  mounted() {
  },
  beforeDestroy() {},
  destroyed() {},
  methods: {
    handleChange(){},
    selectQuarter(index){
      if(this.itemDisabled(index)) return
      this.selectYear = this.year
      this.selectIndex = index
      let start = this.year + '-01'
      let endMonth = (index + 1) * 3
      const end = this.year + '-' + (endMonth < 10 ? `0${endMonth}` : endMonth)
      if(this.isNoStartOne){
        let startMonth = index * 3 + 1
        start = this.year + '-' + (startMonth < 10 ? `0${startMonth}` : startMonth)
      }
      this.$emit('update:value', [start, end])
      this.$emit('change', [start, end])
      this.show_quarter_range_picker = false;
    },
    handleOpenPicker(){
      this.show_quarter_range_picker = true
    },
    handleClosePicker() {
      this.show_quarter_range_picker = false;
    },
    handlePrevYear(){
      if(this.leftDisabled) return
      this.year = parseInt(this.year) - 1
    },
    handleNextYear(){
      if(this.rightDisabled) return
      this.year = parseInt(this.year) + 1
    }
  }
}
</script>
<style lang="less">

.mark {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0);
  z-index: 999;
}
.right-disabled{
  cursor: not-allowed;
  color: #c0c4cc;
}
.quarter-range {
  display: inline-block;
  position: relative;

  .el-card__body {
    padding: 0;
  }

  .quarter-range-picke__value {
    position: absolute;
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
  }
}

.quarter-range__box-card {
  // width: 500px;
  // padding: 0 3px 20px;
  margin-top: 10px;
  position: absolute;
  z-index: 9999;
  width: 240px;
  &-item{
    width: 100px;
    text-align: center;
    cursor: pointer;
    margin: 12px 0;
    // padding: 0;
  }
  &-item.item_disabled{
    color: #c0c4cc;
    cursor: not-allowed;
  }
  &-item.item_disabled:hover{
    background: none;
    color: #c0c4cc;
    // border-radius: 15px;
  }
  .quarter-range__box-card_box{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
  }
  &-item:hover,&-item.item_selected{
    background: #3b86ff;
    color: #fff;
    border-radius: 15px;
  }
  &-item:nth-child(3){
    margin-top: 0;
  }
  &-item:nth-child(4){
    margin-top: 0;
  }
}

.quarter-range__content {
  display: flex;
  justify-content: space-between;
}
.quarter__header {
  display: flex;
  justify-content: space-between;
  padding: 8px 16px;
  border-bottom: 1px solid #e5e6eb;
  font-size: 12px;
  .el-icon-d-arrow-left,
  .el-icon-d-arrow-right,
  .empty-arrow {
    cursor: pointer;
    width: 24px;
    height: 24px;
    font-size: 12px;
    line-height: 24px;
    text-align: center;
    border-radius: 50%;
    // transition: all .1s cubic-bezier(0, 0, 1, 1);
    user-select: none;

    &:hover {
      background-color: #e5e6eb;
    }
  }
  .el-icon-d-arrow-right.right-disabled{
    &:hover {
      background-color: #fff;
      cursor: not-allowed;
    }
  }
}
// 隐藏原有的选择器
.quarter-range-date-popper {
  display: none;
  cursor: pointer;
}
</style>
